module.exports = __webpack_public_path__ + "img/marble_scarce.9fa48b0c.jpg";